import { render } from "./ProfileMobileIcon.vue?vue&type=template&id=33654442"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/ProfileMobileIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33654442"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33654442', __exports__)) {
    api.reload('33654442', __exports__)
  }
  
  module.hot.accept("./ProfileMobileIcon.vue?vue&type=template&id=33654442", () => {
    api.rerender('33654442', render)
  })

}


export default __exports__